(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.e2-header details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.e2-header details[open]').forEach(details => { if (!details.contains(event.target)) details.open=false; });
  });
})();

// Constant-speed product ribbon; wheel and page scrolling do not affect its pace.
if (!customElements.get('erkon-group-strip')) {
  customElements.define('erkon-group-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const on = (target, event, fn, opts = {}) => target.addEventListener(event, fn, { ...opts, signal: this.abort.signal });
      this.viewport = this.querySelector('.e2-group-viewport');
      this.track = this.querySelector('.e2-group-track');
      this.original = this.querySelector('.e2-group-set');
      this.pauseButton = this.closest('section').querySelector('[data-group-pause]');
      this.base = Number(this.dataset.speed) || 36;
      this.direction = 1;
      this.offset = 0;
      this.visible = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.reduced.matches;
      this.focused = false;
      this.touching = false;
      this.syncingScroll = false;
      this.tick = this.tick.bind(this);
      this.resizeObserver = new ResizeObserver(() => this.rebuild());
      this.resizeObserver.observe(this.viewport);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.start();
        else this.stop();
      }, { threshold: 0.01 });
      this.intersectionObserver.observe(this);
      on(this.pauseButton, 'click', () => {
        this.userPaused = !this.userPaused;
        if (this.userPaused) this.stop();
        else this.start();
        this.updateButton();
      });
      on(this.reduced, 'change', () => { this.userPaused = this.reduced.matches; this.rebuild(); this.updateButton(); this.start(); });
      on(document, 'visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });
      on(this.viewport, 'scroll', () => {
        if (this.syncingScroll || (!this.focused && !this.touching) || !this.period || !this.viewport.scrollLeft) return;
        this.offset = this.wrap(this.offset + this.viewport.scrollLeft);
        this.syncingScroll = true;
        this.viewport.scrollLeft = 0;
        this.syncingScroll = false;
        this.paint();
      }, { passive: true });
      on(this.viewport, 'pointerdown', event => { if (event.pointerType !== 'mouse') this.touching = true; });
      on(window, 'pointerup', () => { this.touching = false; this.start(); });
      on(window, 'pointercancel', () => { this.touching = false; this.start(); });
      on(this.viewport, 'focusin', () => { this.focused = true; });
      on(this.viewport, 'focusout', () => {
        queueMicrotask(() => { this.focused = this.viewport.contains(document.activeElement); this.start(); });
      });
      this.closest('section').querySelectorAll('[data-group-step]').forEach(button => {
        button.hidden = false;
        on(button, 'click', () => {
          this.userPaused = true;
          this.stop();
          this.updateButton();
          const distance = Math.max(180, this.viewport.clientWidth * 0.8) * Number(button.dataset.groupStep);
          if (this.reduced.matches) this.viewport.scrollBy({ left: distance, behavior: 'instant' });
          else if (this.period) {
            this.offset = this.wrap(this.offset + distance);
            this.paint();
          }
        });
      });
      this.pauseButton.hidden = false;
      this.updateButton();
      this.rebuild();
    }
    wrap(value) {
      return this.period ? ((value % this.period) + this.period) % this.period : 0;
    }
    paint() {
      if (!this.track) return;
      if (this.reduced.matches) this.track.style.removeProperty('transform');
      else this.track.style.transform = `translate3d(${-this.offset}px,0,0)`;
    }
    rebuild() {
      this.track.querySelectorAll('[data-group-copy]').forEach(el => el.remove());
      this.period = this.original.getBoundingClientRect().width;
      if (!this.period) return;
      if (!this.reduced.matches) {
        const copies = Math.max(2, Math.ceil(this.viewport.clientWidth / this.period) + 1);
        for (let i = 0; i < copies; i++) {
          const copy = this.original.cloneNode(true);
          copy.dataset.groupCopy = '';
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('role');
          copy.querySelectorAll('a,button,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
          this.track.append(copy);
        }
      }
      this.offset = this.wrap(this.offset);
      this.viewport.scrollLeft = 0;
      this.dataset.direction = this.direction > 0 ? 'left' : 'right';
      this.paint();
      this.start();
    }
    updateButton() {
      this.pauseButton.hidden = this.reduced.matches;
      this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
      this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Ürün grubu şeridini oynat' : 'Ürün grubu şeridini duraklat');
      this.pauseButton.querySelector('[data-group-pause-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
    }
    start() {
      if (this.raf || !this.visible || document.hidden || this.userPaused || this.reduced.matches) return;
      this.lastFrame = performance.now();
      this.raf = requestAnimationFrame(this.tick);
    }
    stop() {
      cancelAnimationFrame(this.raf);
      this.raf = 0;
    }
    tick(now) {
      this.raf = 0;
      if (!this.isConnected || !this.visible || document.hidden || this.userPaused || this.reduced.matches) return;
      const dt = Math.min((now - this.lastFrame) / 1000, 0.04);
      this.lastFrame = now;
      if (!this.focused && !this.touching && this.period) {
        this.offset = this.wrap(this.offset + this.direction * this.base * dt);
        this.paint();
      }
      this.raf = requestAnimationFrame(this.tick);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.stop();
      this.track?.querySelectorAll('[data-group-copy]').forEach(el => el.remove());
    }
  });
}
